import { articleAnchorId, paletteFor } from '../../lib/briefModel.js';
import { scrollToBriefTarget } from './briefScroll.js';

function SummaryBody({ model }) {
  const fallback =
    model.overview?.thesis?.trim() ||
    'No red thread has been drafted for this edition yet.';
  const segments =
    model.overview?.segments?.length > 0
      ? model.overview.segments
      : [{ type: 'text', text: fallback }];

  return (
    <p className="font-sans text-[17px] sm:text-[18px] leading-[1.6] text-black m-0">
      {segments.map((seg, i) => {
        if (seg.type === 'link' && seg.articleId) {
          const pal = paletteFor(seg.category);
          const hash = `#${articleAnchorId(seg.articleId)}`;
          return (
            <a
              key={`link-${seg.articleId}-${i}`}
              href={hash}
              className="font-semibold underline decoration-2 underline-offset-[3px] hover:opacity-80"
              style={{ color: pal.bar, textDecorationColor: pal.bar }}
              onClick={(e) => {
                e.preventDefault();
                scrollToBriefTarget(hash);
              }}
            >
              {seg.text}
            </a>
          );
        }
        return <span key={`text-${i}`}>{seg.text}</span>;
      })}
    </p>
  );
}

export default function BriefDailySummary({ model }) {
  const bullets = (model.overview?.bullets || []).filter(Boolean);

  return (
    <section id="daily-summary" className="scroll-mt-28 mb-10 border border-black bg-[#FFF6E8]">
      <div className="px-6 sm:px-8 py-7 sm:py-8">
        <div className="flex items-center gap-3.5 mb-4">
          <span className="font-mono text-[12px] sm:text-[13px] tracking-[0.28em] uppercase text-black font-bold whitespace-nowrap">
            Today&apos;s Brief
          </span>
          <div className="flex-1 border-b border-black" aria-hidden="true" />
        </div>

        <h2 className="font-sans font-black text-[28px] sm:text-[32px] leading-none uppercase text-black tracking-tight">
          Daily Summary
        </h2>
        <p className="font-mono text-[12px] sm:text-[13px] tracking-[0.14em] text-[#737373] mt-2 mb-6">
          Strategic Impact Summary for{' '}
          <em className="text-[#525252] font-semibold not-italic">
            {model.briefDate || 'today'}
          </em>
        </p>

        <SummaryBody model={model} />

        {bullets.length > 0 && (
          <ul className="mt-5 space-y-2 text-[16px] sm:text-[17px] text-[#222] list-disc pl-5 leading-relaxed">
            {bullets.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
